// Minimal i18n seam for the landing site.
//
// Swedish is the default locale and keeps its original URLs (/, /foretag, …).
// Every other locale lives under its own prefix (/en, /de, /no, …) via a
// dedicated root layout in src/app/<locale>/. Page components take a `locale`
// prop and pick their copy from a local dictionary — there is no runtime i18n
// library.
export type Locale = "sv" | "en" | "no" | "da" | "fi" | "de" | "cs" | "zh";

export const DEFAULT_LOCALE: Locale = "sv";

export const LOCALES: Locale[] = ["sv", "en", "no", "da", "fi", "de", "cs", "zh"];

export const LOCALE_NAMES: Record<Locale, string> = {
  sv: "Svenska",
  en: "English",
  no: "Norsk",
  da: "Dansk",
  fi: "Suomi",
  de: "Deutsch",
  cs: "Čeština",
  zh: "中文",
};

export function otherLocale(locale: Locale): Locale {
  return locale === DEFAULT_LOCALE ? "en" : DEFAULT_LOCALE;
}

/**
 * Map a canonical (Swedish) path to its URL in the given locale.
 * localePath("en", "/foretag") -> "/en/foretag"; localePath("sv", "/") -> "/".
 */
export function localePath(locale: Locale, path: string): string {
  if (locale === DEFAULT_LOCALE) return path;
  return path === "/" ? `/${locale}` : `/${locale}${path}`;
}

/** hreflang map for a page that exists in every locale. */
export function languageAlternates(path: string) {
  const languages = Object.fromEntries(
    LOCALES.map((locale) => [locale, localePath(locale, path)]),
  ) as Record<Locale, string>;
  return {
    ...languages,
    "x-default": localePath(DEFAULT_LOCALE, path),
  };
}
